import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { BaseService } from './base.service';
import { SearchModel } from '../models/searchModel';
import { ReservationSearchModel } from '../models/reservationSearchModel';
import { ReservationDetailSearchModel } from '../models/reservation-detail-search-model';

@Injectable()
export class ReservationService extends BaseService {
    constructor(protected http: Http) {
        super('reservations', http);
    }
    list(searchModel: SearchModel = {}, isArchived?: Boolean) {
        if (searchModel.filterId === null) searchModel.filterId = '';
        return this.http
            .get('/' + this.path + '/list', {
                params: {
                    filterId: searchModel.filterId,
                    query: searchModel.query,
                    isArchived: isArchived
                }
            })
            .map(this.extractData);
    }

    getReservationAdUnitClosedDates(adUnitId) {
        return this.http
            .get('/' + this.path + '/GetReservationAdUnitClosedDates', {
                params: {
                    adUnitId: adUnitId
                }
            })
            .map(this.extractData);
    }

    deleteReservationDetailDate(id) {
        return this.http
            .post('/' + this.path + '/DeleteReservationDetailDate/' + id, null)
            .map(this.extractData);
    }

    search(reservationSearchModel: ReservationSearchModel = {}) {
        return this.http
            .post('/' + this.path + '/search', reservationSearchModel)
            .map(this.extractData);
    }

    reservationDetailSearch(
        reservationDetailSearchModel: ReservationDetailSearchModel
    ) {
        return this.http
            .post(
            '/' + this.path + '/reservationdetailsearch',
            reservationDetailSearchModel
            )
            .map(this.extractData);
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/services/reservation.service.ts